module.exports = __webpack_public_path__ + "img/place_config.303bcaa4.png";